import { ActionIcon, Flex, Modal, Text } from '@mantine/core';
import { ShareMenuProps } from './types';
import { FC } from 'react';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'next-i18next';
import {
  FacebookShareButton,
  FacebookIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from 'next-share';

const SHARE_OPTIONS = [
  {
    icon: <PaperClipIcon width={32} />,
    type: 'copy',
    index: 0,
    text: 'menu.copy',
  },
];

export const ShareMenu: FC<ShareMenuProps> = ({
  isModalOpen,
  onCloseModal,
  link,
  title,
}) => {
  const { t } = useTranslation('dashboard');

  const handleShareOption = (option: {
    icon: JSX.Element;
    type: string;
    index: number;
  }) => {
    if (option.type === 'copy' && link) {
      navigator.clipboard.writeText(link);
    }
  };

  return (
    <Modal
      padding={24}
      title={
        <Text variant="subtitle1" component="span">
          {t('menu.share')}
        </Text>
      }
      opened={isModalOpen}
      onClose={onCloseModal}
      centered
    >
      <Flex
        mt={4}
        wrap="wrap"
        align="center"
        direction="row"
        gap={{ base: 4, md: 0 }}
        justify="space-between"
      >
        {SHARE_OPTIONS.map((option) => (
          <ActionIcon
            mt={-6}
            key={option.index}
            onClick={() => handleShareOption(option)}
            variant="roundedGray"
            w={38.5}
            h={38.5}
            aria-label={`$link-${link}`}
            id={`$link-${link}`}
          >
            {option.icon}
          </ActionIcon>
        ))}
        <FacebookShareButton url={link ?? ''}>
          <FacebookIcon size={40} round />
        </FacebookShareButton>
        <TwitterShareButton title={title} url={link ?? ''}>
          <TwitterIcon size={40} round />
        </TwitterShareButton>
        <WhatsappShareButton title={title} url={link ?? ''} separator=":: ">
          <WhatsappIcon size={40} round />
        </WhatsappShareButton>
        <EmailShareButton subject={title} url={link ?? ''}>
          <EmailIcon size={40} round />
        </EmailShareButton>
      </Flex>
    </Modal>
  );
};
